import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_warehouse_sites: { message: "idle" },
};

export const retrieve_warehouse_sites_Slice = createSlice({
 name: "retrieve_warehouse_sites",
 initialState,
 reducers: {
  success_retrieve_warehouse_sites: (state, action) => {
   state.retrieve_warehouse_sites = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_warehouse_sites: (state, action) => {
   state.retrieve_warehouse_sites = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_warehouse_sites: (state) => {
   state.retrieve_warehouse_sites = { status: app_consts.IDLE };
  },
  loading_retrieve_warehouse_sites: (state) => {
   state.retrieve_warehouse_sites = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_warehouse_sites, fail_retrieve_warehouse_sites, reset_retrieve_warehouse_sites, loading_retrieve_warehouse_sites } = retrieve_warehouse_sites_Slice.actions;

export default retrieve_warehouse_sites_Slice.reducer;